
import { NavigationKey } from '../../../types';

export const navigation: Record<NavigationKey, string> = {
  welcome: 'Benvenuto',
  dashboard: 'Dashboard',
  myVideos: 'I Miei Video',
  analytics: 'Analisi',
  settings: 'Impostazioni',
  profile: 'Profilo',
  logout: 'Esci',
  feed: 'Feed',
  latestVideos: 'Video Recenti',
  finance: 'Finanza',
  support: 'Supporto',
  tracking: 'Monitoraggio',
  integrations: 'Integrazioni',
  security: 'Sicurezza',
  partners: 'Partner',
  help: 'Aiuto',
  início: 'Home',
  novoVídeo: 'Nuovo Video',
  personalização: 'Personalizzazione',
  funnelVideo: 'Imbuto Video',
  vsleads: 'VSLeads',
  métricas: 'Metriche',
  testeAB: 'Test A/B',
  hookTrack: 'Teste de hook',
  rastreamento: 'Monitoraggio',
  integrações: 'Integrazioni',
  segurança: 'Sicurezza',
  proteçãoDomínios: 'Protezione Dominio',
  cloakerVSL: 'Cloaker VSL',
  parceiros: 'Partner',
  membros: 'Membri',
  botaoAcao: 'Pulsante di Azione',
  ajuda: 'Aiuto',
  masterClass: 'Master Class',
  capturaLeads: 'Cattura Lead',
  centralAjuda: 'Centro Assistenza',
  chat: 'Chat',
  cloaker: 'Cloaker',
  dominios: 'Domini',
  compartilhar: 'Condividi',
  personalizar: 'Personalizza',
};
